export var Global = {
    // url: 'http://localhost/server_legajo2/public/api',
    // url:'http://172.176.145.53/server_legajo2/public/api',
    url: 'https://applegajoserver.lavoroperu.pe/api',
    info: 'infoLefajo',
    infoTime: 'infoExpirationLefajo',
    infoName: "AppLegajo",
    path: null,
};